<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    name: string
    placeholder?: string
    label?: string
    variant?: `default` | `price` | 'surface'
    error?: string
    clearable?: boolean
    autocomplete?: 'on' | 'off'
  }>(), {
    variant: `default`,
    clearable: false,
    autocomplete: 'on',
  },
);

const emit = defineEmits<{
  focus: []
}>();

const modelValue = defineModel<number>();
const unit = computed(() => {
  if (props.variant === `price`) return `€`;
  if (props.variant === `surface`) return `m²`;
  return ``;
});

const hasError = computed(() => !!props.error);

function onUpdate(event: Event) {
  const target = event.target as HTMLInputElement;
  if (!target.value) return modelValue.value = undefined;
  const value = Number.parseFloat(target.value);
  if (isNaN(value)) return;
  modelValue.value = value;
}
</script>

<template>
  <div class="group">
    <IadLabel
      :html-for="name"
      :text="label"
      :error
    />
    <div
      class="border focus-within:border-secondary rounded-md flex items-center group/input_number "
      :class="{
        'border-neutral-30': !hasError,
        'border-error': hasError,
      }"
    >
      <input
        :id="name"
        :value="modelValue"
        :name
        inputmode="numeric"
        class="flex-1 min-w-0 outline-none bg-transparent
            placeholder:text-neutral placeholder:font-medium
            px-s py-xs"
        :placeholder
        :autocomplete
        @input="onUpdate"
        @focus="emit('focus')"
      >
      <button
        v-if="clearable"
        class="flex-none p-xs rounded-full me-xs opacity-0 group-hover/input_number:opacity-100 hover:bg-neutral-80"
        @click="modelValue = undefined"
      >
        <Icon name="iad-icon:close" />
      </button>
      <span
        class="flex-none pe-s text-neutral-30 empty:hidden"
        v-text="unit"
      />
    </div>
    <IadInputError :error />
  </div>
</template>
